import { z } from "zod";
import { UserType, UserStatus } from "../../lib/enums";

// ----- Input schemas -----

export const ChangeEmailInputSchema = z.object({
  new_email: z.string().email("Invalid email address"),
});

// ----- Output schemas -----

export const AccountSettingsGetOutputSchema = z.object({
  user_type: z.nativeEnum(UserType),
  user_status: z.nativeEnum(UserStatus),
  email: z.string().nullable(),
  created_at: z.string().nullable(),
});

export const ChangeEmailOutputSchema = z.object({
  success: z.boolean(),
});

// ----- Inferred types -----

export type ChangeEmailInput = z.infer<typeof ChangeEmailInputSchema>;
export type AccountSettingsGetOutput = z.infer<typeof AccountSettingsGetOutputSchema>;
export type ChangeEmailOutput = z.infer<typeof ChangeEmailOutputSchema>;
